import ColorPropMixin from './color-prop-mixin';
export default {
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  props: {
    small: {
      description: 'Small Button size',
      default: false,
      type: Boolean
    },
    large: {
      description: 'Large Button size',
      default: false,
      type: Boolean
    },
    disabled: {
      description: 'Is Button disabled',
      default: false,
      type: Boolean
    },
    pill: {
      description: 'Pill Style Button',
      default: false,
      type: Boolean
    },
    square: {
      description: 'Square Style Button',
      default: false,
      type: Boolean
    },
    block: {
      description: 'Block Button Style',
      default: false,
      type: Boolean
    },
    outline: {
      description: 'Outlined Button Style',
      default: false,
      type: Boolean
    },
    icon: {
      description: 'Button Icon Type',
      type: String,
      default: null
    },
    iconFamily: {
      description: 'Button Icon Font Family',
      type: String,
      default: null
    },
    iconOnly: {
      description: 'Show Icon Only',
      default: false, type: Boolean
    },
    kind: {
      type: String,
      description: 'Button Color/Style',
      default: 'primary',
      validator: val =>
        [
          'default',
          'primary',
          'secondary',
          'ghost',
          'danger',
          'dark',
          'success',
          'info',
          'warning',
          'blue',
          'azure',
          'indigo',
          'purple',
          'pink',
          'red',
          'orange',
          'yellow',
          'lime',
          'green',
          'teal',
          'cyan',
          'gray',
          'gray-dark',
        ].includes(val)
    }
  },
  mixins: [ColorPropMixin],
  computed: {
    iconSize() {
      if (this.large && !this.small) return 18;
      if (this.small && !this.large) return 14;
      return 16;
    },

  }
}